import React, { useMemo } from 'react';
import { Select } from 'antd';
import { isNotNullish } from 'utils/nullish';
import { ze } from 'utils/zhEn';
import IosModelSelect from './IosModelSelect';

const IosDeviceSelect = ({
  appId,
  isReadOnly,
  fieldValue,
  onChangeFieldValue = () => {},
}) => {
  // 延迟导入 QueryType 避免循环依赖
  const { QueryType } = require('components/commons/IssueCrashFilter/IssueCrashFilterExUtil');
  
  const SearchMethod = useMemo(() => ({
    IN: 'IN',
    NOT_IN: 'NOT_IN',
  }), []);

  const SearchMethodToInfo = useMemo(() => ({
    [SearchMethod.IN]: {
      queryType: QueryType.TERMS,
      not: false,
    },
    [SearchMethod.NOT_IN]: {
      queryType: QueryType.TERMS,
      not: true,
    },
  }), [SearchMethod.IN, SearchMethod.NOT_IN, QueryType.TERMS]);

  const QUERY_TYPE_OPTIONS = useMemo(() => [
    { name: ze('包含', 'Contains'), value: SearchMethod.IN },
    { name: ze('不包含', 'Not Contains'), value: SearchMethod.NOT_IN },
  ].map(x => ({
    ...x,
    label: x.name,
  })), [SearchMethod.IN, SearchMethod.NOT_IN]);

  const findSearchMethod = (queryType, not) => {
    const SearchMethodInfoEntries = Object.entries(SearchMethodToInfo);
    const foundEntry = SearchMethodInfoEntries.find(([k, v]) => {
      return v.queryType === queryType && v.not === Boolean(not);
    });
    return isNotNullish(foundEntry) ? foundEntry[0] : null;
  };

  const {
    queryType: nullableQueryType,
    not,
    terms,
  } = fieldValue || {};

  const queryType = nullableQueryType || QueryType.TERMS;
  let searchMethodValue = findSearchMethod(queryType, not);
  if (!searchMethodValue) {
    searchMethodValue = SearchMethod.IN;
  }

  return <div style={{ display: 'flex' }}>
    <Select
      style={{ width: '120px', flex: '0 0 auto' }}
      options={QUERY_TYPE_OPTIONS}
      optionFilterProp='name'
      optionLabelProp='name'
      value={searchMethodValue}
      onChange={(v) => {
        if (isReadOnly) {
          return;
        }
        const newInfo = SearchMethodToInfo[v];
        onChangeFieldValue({ queryType: newInfo.queryType, not: newInfo.not, terms });
      }}
    />
    <IosModelSelect
      appId={appId}
      isReadOnly={isReadOnly}
      value={terms}
      onChange={(v) => onChangeFieldValue({ queryType, not, terms: v })}
    />
  </div>
};

export default IosDeviceSelect;
